// 모듈 안에서 주고받는 유일한 에러 봉투. kind·severity 를 생성 시점에 강제해 "분류 없는 에러" 를
// 만들 수 없게 하고, 원본은 cause 에 보존해 도구가 체인으로 보여줄 수 있게 한다.

export type ErrorKind = 'API' | 'network' | 'client'
export type ErrorSeverity = 'fatal' | 'error' | 'warning'
export type ErrorOrigin = 'ours' | 'external' | 'environment' | 'unknown'
export type ErrorMechanism =
  | 'interceptor'
  | 'boundary'
  | 'onerror'
  | 'unhandledrejection'
  | 'boot'
  | 'manual'
export type ErrorFlow = 'payment'

export type AppErrorOptions = {
  kind: ErrorKind
  severity: ErrorSeverity
  origin?: ErrorOrigin
  code?: string
  userMessage?: string
  cause?: unknown
  status?: number
  method?: string
  urlPath?: string
  route?: string
  flow?: ErrorFlow
  mechanism?: ErrorMechanism
}

export class AppError extends Error {
  override readonly name = 'AppError'
  readonly kind: ErrorKind
  readonly severity: ErrorSeverity
  // classify 만 바꾼다. 생성 시점 값은 기본 ours.
  origin: ErrorOrigin
  readonly code?: string
  readonly userMessage?: string
  readonly status?: number
  readonly method?: string
  readonly urlPath?: string
  readonly route?: string
  // capture 컨텍스트가 뒤늦게 채울 수 있다(결제 인터셉터의 날것 AxiosError 경로).
  flow?: ErrorFlow
  mechanism?: ErrorMechanism

  constructor(message: string, options: AppErrorOptions) {
    super(message, { cause: options.cause })
    this.kind = options.kind
    this.severity = options.severity
    this.origin = options.origin ?? 'ours'
    this.code = options.code
    this.userMessage = options.userMessage
    this.status = options.status
    this.method = options.method
    this.urlPath = options.urlPath
    this.route = options.route
    this.flow = options.flow
    this.mechanism = options.mechanism

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, AppError)
    }
  }
}

export const isAppError = (value: unknown): value is AppError => value instanceof AppError
